// @flow
import React, { createContext, useContext } from 'react';
import type { Node } from 'react';
import type { Source } from '../types';

type Context = $ReadOnly<{
    source: ?Source
}>;

const SourceContext = createContext<Context>({});

type Props = $ReadOnly<{
    source: ?Source,
    children: Node
}>;

export const SourceProvider = ({ source, children }: Props) => {
    const context = {
        source
    };

    return (
        <SourceContext.Provider value={context}>
            {children}
        </SourceContext.Provider>
    );
};

export const useSourceContext = () => useContext(SourceContext);

export const useSource = () => {
    const context = useSourceContext();
    return context.source;
};